import { parseAsString, parseAsStringLiteral, useQueryStates } from "nuqs";
import { TaskStatusSchema, TaskTypeSchema } from "@myapp/contract";
import {
  INITIAL_AUFGABEN_FILTERS,
  AufgabenFiltersForm,
} from "./aufgabenFilters.types";
import type { StatusFilterValue } from "../../../../entities/task";

const STATUS_FILTER_VALUES = [...TaskStatusSchema.options, "NEEDS_RESCHEDULING"] as const satisfies readonly StatusFilterValue[];

const SORT_FIELDS = new Set<AufgabenFiltersForm["sortField"]>([
  "title",
  "plannedStart",
  "deadline",
  "taskType",
  "technicianName",
  "plannedWorkDuration",
  "plannedTravelDuration",
]);

const SORT_DIRECTIONS = new Set<AufgabenFiltersForm["sortDirection"]>([
  "ASC",
  "DESC",
]);

export const useAufgabenFiltersParams = () =>
  useQueryStates(
    {
      technicianName: parseAsString.withDefault(INITIAL_AUFGABEN_FILTERS.technicianName),
      taskType: parseAsStringLiteral(TaskTypeSchema.options),
      status: parseAsStringLiteral(STATUS_FILTER_VALUES),
      title: parseAsString.withDefault(INITIAL_AUFGABEN_FILTERS.title),
      plannedStart: parseAsString.withDefault(INITIAL_AUFGABEN_FILTERS.plannedStart),
      deadline: parseAsString.withDefault(INITIAL_AUFGABEN_FILTERS.deadline),
      sortField: parseAsString.withDefault(INITIAL_AUFGABEN_FILTERS.sortField),
      sortDirection: parseAsString.withDefault(INITIAL_AUFGABEN_FILTERS.sortDirection),
    },
    {
      clearOnDefault: true,
    },
  );

export type AufgabenFiltersParams = ReturnType<typeof useAufgabenFiltersParams>[0];

export const toAufgabenFiltersForm = (
  params: AufgabenFiltersParams,
): AufgabenFiltersForm => ({
  technicianName: params.technicianName,
  taskType: params.taskType,
  status: params.status,
  title: params.title,
  plannedStart: params.plannedStart,
  deadline: params.deadline,
  sortField: SORT_FIELDS.has(params.sortField as AufgabenFiltersForm["sortField"])
    ? (params.sortField as AufgabenFiltersForm["sortField"])
    : INITIAL_AUFGABEN_FILTERS.sortField,
  sortDirection: SORT_DIRECTIONS.has(
    params.sortDirection as AufgabenFiltersForm["sortDirection"],
  )
    ? (params.sortDirection as AufgabenFiltersForm["sortDirection"])
    : INITIAL_AUFGABEN_FILTERS.sortDirection,
});
